import { useRef, useCallback, memo } from 'react'
import { useTranslation } from 'react-i18next'

import CustomButton from 'components/Shared/Button/index'
import CustomDialog from 'components/Shared/Dialog'
import SaveModalDataContent from 'components/Reporting/Overview/FilterBuilder/FilterSet/FilterDialogue/SaveContent'
import { useAppSelector } from 'redux/Hook'

const RenameFilterSet = ({
  testProps = false,
  handleRenameSelection,
  onCloseModal,
  visibility,
}: any) => {
  const { t } = useTranslation()

  const inputRef: any = useRef('')
  const setUserInput = (input: any) => {
    inputRef.current = input
  }
  const {
    filterBuilder: {
      savedFilter: {
        filterName: savedFilter = '',
        originalFilterName = '',
        filterId = '',
      } = {},
    } = {},
  }: any = useAppSelector((state) => state)
  const saveModalProps = {
    setUserInput,
    userInput: inputRef.current,
    t,
    savedFilter,
    originalFilterName,
    filterSetName: 'rename',
  }

  const onSave = useCallback(async () => {
    const { textValue: { text: filterName = '' } = {}, updateValue } =
      inputRef?.current || {}

    if (!filterName?.length) {
      updateValue({
        isError: true,
        text: filterName,
        validation: t('reporting.filterSet.requiredFiled'),
        position: 'left',
      })
    } else {
      const result = await handleRenameSelection(filterId, filterName, inputRef)

      if (result) {
        onCloseModal('rename')
      }
    }
  }, [filterId])

  const customDialogProps = {
    title: t('reporting.filterSet.renameFilterSet'),
    showCloseBtn: true,
    enableActionButtons: true,
    content: <SaveModalDataContent {...saveModalProps} />,
    onCloseModal: () => onCloseModal('rename'),
    isModalOpen: visibility,
    primaryBtn: (
      <CustomButton
        title={t('reporting.filterSet.save')}
        btnVariant="contained"
        onClick={onSave}
      />
    ),
    secondaryBtn: (
      <CustomButton
        title={t('reporting.filterSet.cancel')}
        disabled={false}
        onClick={() => onCloseModal('rename')}
      />
    ),
    ...(testProps && {
      testProps: {
        disablePortal: true,
        hideBackdrop: true,
        TransitionComponent: ({ children }: any) => children,
      },
    }),
  }

  return <CustomDialog {...customDialogProps} />
}

export default memo(RenameFilterSet)
